import React, { createContext, useState, useEffect } from "react";
import apiRoot from "../api/apiRoot";

export const ClientContext = createContext();

export const ClientStore = ({ children }) => {
  const [clients, setClients] = useState([]);
  const [currentClient, setCurrentClient] = useState(null);
  const [currentSet, setCurrentSet] = useState(null);
  const [items, setItems] = useState([]);
  const [currentApp, setCurrentApp] = useState("Color");
  const [currentSetId, setCurrentSetId] = useState(null);
  const [currentClientId, setCurrentClientId] = useState("");

  const getClients = async () => {
    const response = await apiRoot.post("/retrieveClients", {});
    setClients(response.data); // update your state
  };

  useEffect(() => {
    getClients();
  }, []);

  useEffect(() => {
    if (!currentClient && currentClientId) {
      setCurrentClient(clients.filter((client) => client.clientid === currentClientId)[0]);
    }
  }, [clients]);

  useEffect(() => {
    getClient(currentClientId);
  }, [currentClientId]);

  useEffect(() => {
    if (currentClient) {
      setItems(currentClient[currentApp]);
    }
  }, [currentClient, currentApp]);

  useEffect(() => {
    if (currentSetId && currentClient) {
      try {
        setCurrentSet(currentClient[currentApp].filter((item) => item.setId === currentSetId)[0]);
      } catch (error) {
        console.log(error);
      }
    }
  }, [currentSetId, currentClient]);

  const getSetData = (setid) => {
    setCurrentSetId(setid);
  };

  const getClient = (clientid) => {
    if (clients.length === 0) {
      getClients();
    }
    setCurrentClient(clients.filter((client) => client.clientid === clientid)[0]);
  };

  const updateCurrentSet = (newSet, reset) => {
    let newCurrentSet;
    if (reset) {
      newCurrentSet = { ...currentSet, ColorRows: newSet };
    } else {
      const newColorRows = { ...currentSet.ColorRows, ...{ [newSet.color]: newSet } };
      newCurrentSet = { ...currentSet, ColorRows: newColorRows };
    }
    setCurrentSet(newCurrentSet);
    const newItems = items.map((item) =>
      item.setId === newCurrentSet.setId ? newCurrentSet : item
    );
    setItems(newItems);
    updateClient({ [currentApp]: newItems });
  };

  const updateTypographySet = (typographyData) => {
    updateClient({ Typography: [{ setName: "default", data: typographyData }] });
  };

  const updateTypographyAssignments = (typographyData) => {
    console.log(typographyData);
  };

  function updateClient(appSet) {
    if (!currentClient) {
      getClients();
    } else {
      const newDoc = { ...currentClient, ...appSet };
      setCurrentClient(newDoc);
      apiRoot.post("/saveClient", {
        newDoc: newDoc,
      });
      const newClients = clients.map((client) => {
        return client.clientid === currentClient.clientid ? newDoc : client;
      });
      setClients(newClients);
    }
  }

  const value = {
    clients: clients,
    currentClient: currentClient,
    items: items,
    currentSet: currentSet,
    updateClient: updateClient,
    getClients: getClients,
    getClient: getClient,
    setCurrentClient: setCurrentClient,
    setCurrentSet: setCurrentSet,
    updateCurrentSet: updateCurrentSet,
    getSetData: getSetData,
    updateTypographySet: updateTypographySet,
    currentClientId: currentClientId,
    setCurrentClientId: setCurrentClientId,
    updateTypographyAssignments: updateTypographyAssignments,
  };

  return <ClientContext.Provider value={value}>{children}</ClientContext.Provider>;
};
